import {
    faApple,
    faWindows,
    IconDefinition
  } from "@fortawesome/free-brands-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { Box, Hidden, IconButton, Typography } from "@mui/material";
import AboutGarudaBackgroundImage from "./AboutGarudaBackgroundImage";
import SectionTitle from "../../../components/SectionTitle";
import GarudaInstallerSelectionButton from "./GarudaInstallerSelectionButton";
import styles from "./css/IntroCard.module.css";

interface OSIconProps {
    iconName: IconDefinition;
  }

const OSIcon = ({ iconName }: OSIconProps) => {
    return (
    <IconButton className={styles.icon}>
        <FontAwesomeIcon icon={iconName} className={styles.osIconBtn} />
    </IconButton>
    );
};

const DownloadSection = () => (
    <>
        <Box data-testid="os-icon-list" className={styles.osIconList}>
            <OSIcon iconName={faApple} />
            <OSIcon iconName={faWindows} />
        </Box>
        <div className={styles.buttonContainer}>
            <GarudaInstallerSelectionButton />
            {/* <GarudifyGadgetsButton /> */}
        </div>
    </>
)

export const IntroCard = () => {
    return (
        <AboutGarudaBackgroundImage>
            <SectionTitle
                dataTestId="garuda-2x-for-you"
                value="GARUDA FOR YOU"
            />
            <Typography variant="body1" data-testid="about-garuda-text">
                Garuda is a powerful platform that provides a framework to connect, discover and navigate through different 
                cutting-edge applications, databases and services in biology, healthcare and across diverse domains.
            </Typography>
            <Hidden mdDown>
                <DownloadSection />
            </Hidden>
        </AboutGarudaBackgroundImage>
    )
}